import React from 'react';
import {getApiUrl} from "../service/Api";
import {getIcon} from "../service/Icon";

class MemberCard extends React.Component {

    static defaultProps = {
        withLocation: false,
        onClick: () => {},
        member: {},
        categories: []
    }

    renderCategories = (categories) => {

        let list = [];

        categories.forEach(category => {
            let cat = this.props.categories.find((gCategory, index) => {
                if (parseInt(gCategory.category_id) === parseInt(category)) {
                    return true;
                }
                return false;
            });

            if (cat) {
                list.push(
                    <span>
                        <img src={'/wp-content/plugins/dsz-wordpress-list/map/build/' + getIcon(cat.category_slug)}
                             width={20} alt={cat.category_title}/> {cat.category_title}
                    </span>
                )
            }

        })

        return list;
    }

    render() {

        const {
            member,
            onClick
        } = this.props;

        let categories = member.member_category_ids.split(',');
        // eslint-disable-next-line
        let backgroundImage = 'url(' + getApiUrl() + 'imageout/' + member.coverimage_id + '/h_' + member.member_post_name + '.jpg?width=508&height=200' + ')';

        return (
            <div className="">
                <div className="cont" key={'memberlist_' + member.member_id}>
                    <a
                        className="member-card"
                        href={'/listing/' + member.member_post_name}
                        title={member.member_post_title}
                        onClick={(event) => {
                            event.preventDefault();
                            onClick();
                        }}
                    >
                        <div
                            className="memberlist-cover"
                            style={{
                                backgroundImage: `${backgroundImage}`
                            }}
                        >
                            <div className="memberlist-cover-overlay"/>
                        </div>
                        <div className="memberlist-image">
                            <img src={getApiUrl() + 'imageout/' + member.profileimage_id + '/l_' + member.member_post_name + '.jpg?width=150&height=150'} loading="lazy"
                                 width="150" height="150" alt={member.member_post_title}/>
                        </div>
                        <div className="memberlist-content">
                            <div className="memberlist-name" dangerouslySetInnerHTML={{__html: member.member_post_title}} />
                            <div className="memberlist-clinic">
                                <span dangerouslySetInnerHTML={{__html: member.member_tagline2}} />
                            </div>
                            <div className="memberlist-address">
                                <span dangerouslySetInnerHTML={{__html: member.member_location}} />
                            </div>
                            <div className="memberlist-department">
                                {
                                    this.renderCategories(categories)
                                }
                            </div>

                        </div>
                    </a>
                </div>
            </div>
        )
    }

}

export default MemberCard;
